import { GetRequest } from '../../service';
const ControllerName = "RolePrivileges"

export const GetRolesPrivilegesByRoleID = (roleID) => {
    return GetRequest(ControllerName + "/" + roleID)
}

